<template>
    <head>
    <meta charset="UTF-8">
    <title> | Habilite-se</title>
    </head>
  <div class="container-fluid">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title"><span class="fa fa-desktop"></span>&nbsp;&nbsp; Documentos</h3>
        <div class="card-toolbar">

          <a class="btn btn-secondary" :href="props.route_to_upload" as=button> Salvar novo template <i class="fa fa-plus"></i></a>
        </div>
      </div>

      <!-- documentos > 0 -->
      <div v-if="props.list_templates.length > 0" class="card-body">
        <div class="table-responsive">
          <table class="table table-striped gs-5">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-center">Download arquivo original</th>
                <th class="text-center">Deletar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in props.list_templates" :key='template' class="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <td class="col-md-7">{{ template.name }}</td>
                <td class="text-center">
                  <a target="_blank" :href="template.temporary_link_download" class="btn btn-sm btn-primary p-5">
                    <i class="fa fa-download"></i>
                  </a>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger p-5"
                    @click="deleteTemplate(template)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-info">Não existem documentos cadastrados.</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { ref } from 'vue';
import { router } from '@inertiajs/vue3';


const props = defineProps({
  list_templates: { type: Object, required: true },
  route_to_upload: { type: String, required: true },
})


var formData = ref({
  download: {
    file: ''
  }
});

type TemplateItem = {
  id: number | string;
  route_to_delete: string;
  name?: string;
};

async function deleteTemplate(template: TemplateItem) {
  const confirmed = window.confirm('Tem certeza que deseja deletar este arquivo?');
  if (!confirmed) return;

  try {
    await axios.delete(template.route_to_delete);

    router.reload({
      only: ['list_templates'],
    });
  } catch (err) {
    console.error(err);
    window.alert('Erro ao deletar o arquivo.');
  }
}

</script>
